import React from 'react';
import PropTypes from 'prop-types';

const Card = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div className={`rounded-lg border bg-card text-card-foreground shadow-sm ${className}`} ref={ref} {...props} />
    )
})

export const CardHeader = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div className={`flex flex-col space-y-1.5 p-6 ${className}`} ref={ref} {...props} />
    )
})

export const CardTitle = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div className={`text-2xl font-semibold leading-none tracking-tight ${className}`} ref={ref} {...props} />
    )
})

export const CardContent = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div className={`p-6  ${className}`} ref={ref} {...props} />
    )
})
export const CardFooter = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div className={`flex items-center p-6 pt-0 ${className}`} ref={ref} {...props} />
    )
})

Card.displayName = "Card"
Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

CardHeader.displayName = "CardHeader"
CardHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

CardTitle.displayName = "CardTitle"
CardTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

CardContent.displayName = "CardContent"
CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

CardFooter.displayName = "CardFooter"
CardFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export { Card }
